<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-26 16:19:58
 * @LastEditTime : 2019-12-31 10:08:22
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <!-- <div class="selectUser_wrapper" v-loading="selectUserLoading" :key="paramsData.key"> -->
  <div class="selectUser_wrapper" v-loading="selectUserLoading">
    <div class="tabs_wrapper" style="position:relative;">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="组织部门" name="1"></el-tab-pane>
        <!-- <el-tab-pane label="用户类型" name="2"></el-tab-pane> -->
        <el-tab-pane label="系统角色" name="3"></el-tab-pane>

        <!-- <el-tab-pane  v-if="!principal" label="负责人" name="4"></el-tab-pane>
        <el-tab-pane label="教师职称" name="5"></el-tab-pane> -->
        <el-tab-pane label="标签用户" name="6"></el-tab-pane>
      </el-tabs>
      <div style="margin-bottom:10px;position:absolute;right:0;top:0;">
        <el-input
          v-model="userName"
          placeholder="请输入姓名"
          style="width:150px;margin-right:10px;"
          @keyup.enter.native="userSearch"
        />
        <el-button type="primary" size="small " @click="userSearch()"
          ><i class="el-icon-search"></i><span>搜索</span>
        </el-button>
        <el-button size="small " @click="clearUserName()"
          ><i class="el-icon-refresh"></i><span>清空</span>
        </el-button>
      </div>
    </div>
    <div
      class="content_wrapper"
      :style="{
        height:
          paramsData.type !== 'radio'
            ? 'calc(100% - 130px) !important'
            : 'calc(100% - 100px) !important'
      }"
    >
      <div
        v-if="['1', '3', '4', '5','6'].includes(activeName)"
        class="content_wrapper_left"
      >
        <p v-if="activeName === '1'" class="head_title">组织部门</p>
        <p v-if="activeName === '3'" class="head_title">系统角色</p>
        <p v-if="activeName === '4'" class="head_title">负责人</p>
        <p v-if="activeName === '5'" class="head_title">职称系列</p>
        <p v-if="activeName === '6'" class="head_title">标签用户</p>
        <treeMenu
          v-if="activeName === '1'"
          ref="treeMenu"
          initId="0"
          :key="treeKey"
          :showBox="false"
          :showFilter="false"
          :showArrow="false"
          :clickedId="handleClickedId"
          loadStyle="staticLoad"
          treeWidth="220px"
          @nodeClick="getNodeId"
          style="height: calc(100% - 35px);"
        ></treeMenu>
        <div v-if="activeName === '3'" class="system_role" :key="treeKey">
          <el-scrollbar style="height: 100%;">
            <el-card class="box-card">
              <div
                v-for="(item, index) in systemRoleData"
                :key="item.roleId"
                :class="[
                  'text',
                  'item',
                  cardActiveId == item.roleId ? 'cardActive' : ''
                ]"
                @click="setSelectedRoleId(item)"
              >
                <span class="left_item">{{ item.roleName }}</span>
              </div>
            </el-card>
          </el-scrollbar>
        </div>
        <div v-if="activeName === '4'" class="person_wrapper" :key="treeKey">
          <el-scrollbar style="height: 100%;padding-bottom:15px;">
            <!-- <el-card class="box-card">
                          <div
                            v-for="(item, index) in personTypeListData"
                            :key="item.deptId"
                            :class="[
                              'text',
                              'item',
                              cardActiveId == item.deptId ? 'cardActive' : ''
                            ]"
                            @click="setSelectedPersonId(item)"
                          >
                            <span class="left_item" v-if="personType > -1">{{
                              item.deptName
                            }}</span>
                            <span class="left_item" v-else>{{ item.name }}</span>
                          </div>
                        </el-card> -->
            <el-tree
              ref="personTree"
              :data="personTypeData"
              :props="defaultProps"
              :default-expanded-keys="defaultExpandIds"
              node-key="id"
              highlight-current
              @node-click="handleNodeClick"
              @node-expand="expendNodeCollapse"
            ></el-tree>
          </el-scrollbar>
        </div>
        <div v-if="activeName === '5'" class="person_wrapper" :key="treeKey">
          <el-scrollbar style="height: 100%;padding-bottom:15px;">
            <el-tree
              ref="seriesTree"
              :data="seriesData"
              :props="defaultSeriesProps"
              :default-expanded-keys="defaultSeriesExpandIds"
              node-key="id"
              highlight-current
              @node-click="handleSeriesNodeClick"
              @node-expand="expendSeriesNodeCollapse"
            ></el-tree>
          </el-scrollbar>
        </div>
        <div v-if="activeName === '6'" class="system_role" :key="treeKey">
          <el-scrollbar style="height: 100%;">
            <el-card class="box-card">
              <div
                      v-for="(item, index) in labelList"
                      :key="item.labelId"
                      :class="[
                  'text',
                  'item',
                  cardActiveId == item.labelId ? 'cardActive' : ''
                ]"
                      @click="setSelectedLabelId(item)"
              >
                <span class="left_item">{{ item.labelName }}</span>
              </div>
            </el-card>
          </el-scrollbar>
        </div>
      </div>
      <div class="content_wrapper_right">
        <div class="content_wrapper_right_table">
          <div class="searchDiv">
            <!-- <div v-if="!['3', '4', '5'].includes(activeName)" class="stateType">
              <p>用户类型：</p>
              <p
                @click="typeClick(item)"
                v-for="(item, index) in typeData"
                :class="type === item.id ? 'typeAffirm' : ''"
              >
                {{ item.label }}
              </p>
            </div> -->
            <!-- <div v-if="activeName === '4'" class="personType">
                          <p>负责人类型：</p>
                           <p
                            @click="personTypeClick(item, index)"
                            v-for="(item, index) in personTypeData"
                            :class="personType === index - 1 ? 'typeAffirm' : ''"
                          >
                             {{ item }}
                          </p>
                        </div> -->
            <div v-if="activeName === '5'" class="teacherType">
              <p>职称等级：</p>
              <p
                @click="teacherTypeClick(item, index)"
                v-for="(item, index) in teacherTypeData"
                :class="teacherType === index - 1 ? 'typeAffirm' : ''"
              >
                {{ item.label }}
              </p>
            </div>
            <div class="stateName">
              <div class="stateList">
                <p

                >
                </p>
              </div>
            </div>
            <!-- <div v-if="activeName === '4'" class="personType"> -->
            <!-- <p>负责人类型：</p> -->
            <!-- <p
                            @click="personTypeClick(item, index)"
                            v-for="(item, index) in personTypeData"
                            :class="personType === index - 1 ? 'typeAffirm' : ''"
                          > -->
            <!-- {{ item }} -->
            <!-- </p> -->
            <!-- </div>                 -->
            <!-- <div class="sortData">
                          <p v-for="(item, index) in sortData">
                            <span
                              @click="sortClick(item, index)"
                              :class="sortType === index ? 'typeAffirm' : ''"
                              >{{ item }}</span
                            >
                            <span style="color: gainsboro">|</span>
                          </p>
                        </div> -->
          </div>
          <!-- <div class="select_wrapper" style="height:calc(100% - 130px)"> -->
          <div
            class="select_wrapper"
            :style="{
              height: ['3', '4'].includes(activeName) ? '400px' : '360px'
            }"
          >
            <div class="select_wrapper_content">
              <!-- <el-scrollbar style="height: 80%;"> -->
              <el-table
                border
                height="calc(100% - 53px)"
                class="table-border"
                ref="multipleRoleUserTable"
                :data="deptUserData"
                tooltip-effect="dark"
                stripe
                style="width: 100%;height:100%;overflow-y: auto"
                @selection-change="selectionChange"
                @select="handleSelect"
                @select-all="allSelectionChange"
              >
                <el-table-column
                  v-if="paramsData.type !== 'radio'"
                  type="selection"
                  width="55"
                  align="center"
                ></el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  width="65"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="200"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="deptName"
                  label="部门"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="type"
                  label="用户类型"
                  width="150"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if=""></span>
                    {{ dealRoleType(scope.row.type) }}
                  </template>
                </el-table-column> -->
                <el-table-column
                  v-if="paramsData.type === 'radio'"
                  prop="type"
                  label="操作"
                  width="150"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small "
                      :type="selectedUserIdArr.includes(Number(scope.row.userId))?'':'primary'"
                      :disabled="selectedUserIdArr.includes(Number(scope.row.userId))"
                      @click="sureClick(false, scope.row)"
                      ><span>选择</span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页start -->
              <!-- v-if="this.selectUser.total > 0"               -->
              <div style="margin-top: 10px;text-align:right;">
                <el-pagination
                  background
                  @current-change="UserCurrentChange"
                  :current-page.sync="selectUser.current"
                  layout="total,prev, pager, next"
                  :total="selectUser.total"
                >
                </el-pagination>
              </div>
              <!-- 分页end -->
              <!-- </el-scrollbar> -->
            </div>
          </div>
        </div>
        <div
          v-if="paramsData.type !== 'radio'"
          class="content_wrapper_right_list"
        >
          <p class="head_title">已选用户<span style="color:red">({{selectedUserListArr.length}}人)</span><span style="padding-left: 20px;cursor: pointer" @click="delAll">清除已选</span></p>
          <div class="right_list_content">
            <el-scrollbar style="height: 100%;">
              <el-card class="box-card">
                <div
                  v-if="selectedUserListArr.length < 1"
                  style="text-align:center;color:#666;"
                >
                  暂无数据
                </div>
                <div
                  v-if="selectedUserListArr.length > 0"
                  v-for="(item, index) in selectedUserListArr"
                  :key="item.directorId || item.userId"
                  class="text item list_item"
                >
                  <span
                    v-if="Object.keys(item).includes('directorId')"
                    class="list_item_name"
                    >{{ item.directorName }}</span
                  >
                  <span
                    v-if="Object.keys(item).includes('userId')"
                    class="list_item_name"
                    >{{ item.name }}</span
                  >
                  <span class="list_item_icon" @click="delSelectedUser(item)"
                    ><i class="el-icon-close"></i
                  ></span>
                </div>
              </el-card>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <div v-if="paramsData.type !== 'radio'" class="dialog-footer">
      <!-- <el-button
              type="primary"
              @click="sureClick(true)"
              style="position:absolute;left:30px;"
              >全部用户</el-button
            > -->
      <el-button type="primary" @click="sureClick(false)"
                 :disabled="sureBtnDisabled"

            >确 认
            </el-button
            >
            <el-button @click="handleDialogClose()">关 闭</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import treeMenu from "@/components/treeMenu/index.vue";
import {
  getMajorsMan,
  getClassMan,
  getSubjectMan,
  getDeptChargeMan
} from "@/api/admin/person";
import { getRoleList, getMixQueryUserPage } from "@/api/dispose/myfillout";
import { getListTableUrl } from "@/api/management/user";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { majorType } from "@/api/charge/major";
import { getAllLabelList } from '@/api/managementCenter/labelManage';

export default {
  name: "selectUser",
  data() {
    return {
      sureBtnDisabled:false,
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      userName: "",
      treeKey: Date.parse(new Date()),
      handleClickedId: {
        data: 0,
        key: Date.parse(new Date())
      },
      selectUser: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      // selectedUserIdArr:this.paramsData.defaultSelected,
      selectedUserIdArr: [],
      selectedUserListArr: [],
      // selectedUserListArr: this.paramsData.selectedUserListArr,
      deptUserData: [],
      chooseAll: false,
      activeName: "1",
      typeData: [
        // {id:0,label:"全部"},
        { id: 1, label: "教师" },
        { id: 2, label: "教职工" }
      ],
      teacherTypeData: [],
      // personTypeData: ["机构", "专业", "班级"],
      personTypeData: [
        { id: 0, label: "机构", level: 1, children: [] },
        { id: 1, label: "专业", level: 1, children: [] },
        { id: 2, label: "班级", level: 1, children: [] },
        { id: 3, label: "分组", level: 1, children: [] }
      ],
      itemName: [
        "全部",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      sortData: ["默认排序", "升序", "降序"],
      type: 1,
      teacherType: -1,
      currentTeacherType: "",
      personType: -1,
      sortType: 0,
      nameIndexValue: 0,
      nameIndex: null,
      sortOrder: true,
      cardActiveId: "",
      personTypeListData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 100, // 每页显示多少条
        sizes: [10, 20, 50, 100]
      },
      params: {
        name: null,
        type: null,
        dimYear: "2019"
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      searchRoleName: "",
      systemRoleData: [],
        labelList: [],
      selectedRoleId: "",
      selectedLabelId: "",
      selectedPersonId: "",
      defaultExpandIds: [],
      selectUserLoading: false,
      defaultSeriesExpandIds: [],
      defaultSeriesProps: {
        children: "children",
        label: "label"
      },
        principal:false,
      seriesData: [],
      currentSeriesId: null
    };
  },
  props: {
    paramsData: {
      type: Object,
      required: true
    }
  },
  components: { treeMenu },
  computed: {
    ...mapGetters([])
  },
  watch: {
    // "paramsData.key"(val) {
    //   this.selectedUserIdArr = [];
    //   this.selectedUserListArr = [];
    // },
    // "paramsData.defaultSelected"(val) {
    //   this.selectedUserIdArr = val;
    // },
    // "paramsData.selectedUserListArr"(val) {
    //   this.selectedUserListArr = val;
    // },
    activeName(value) {
      this.selectedRoleId = "";
      this.selectedLabelId="";
      this.personType = -1;
      this.selectedPersonId = "";
      this.cardActiveId = "";
      this.treeKey = Date.parse(new Date());
      switch (value) {
        case "3":
          this.getRoleListData();
          break;
        case "4":
          this.getDeptChargeManList();
          this.getMajorsManList();
          this.getClassManList();
          this.getSubjectManList();
          this.personTypeData.forEach((item, index) => {
            if (index === 0) {
              this.$nextTick(() => {
                this.defaultExpandIds.push(item.id);
                this.$refs["personTree"].setCurrentKey(item.id);
              });
            }
          });
          this.getMixQueryUserPageData();
          break;
        case "5":
          this.getSeriesData();
          // this.getTeacherType();
          break;
          case "6":
              this.getLabelListFn();
              break;
        default:
          this.getMixQueryUserPageData();
      }
    },
    deptUserData: {
      handler(newVal, oldVal) {
        // this.$nextTick(() => {
        //   if (newVal.length > 0) {
        //     newVal.forEach(item => {
        //       if (this.selectedUserIdArr.includes(Number(item.userId))) {
        //         this.$refs.multipleRoleUserTable.toggleRowSelection(item, true);
        //       } else {
        //         this.$refs.multipleRoleUserTable.toggleRowSelection(
        //           item,
        //           false
        //         );
        //       }
        //     });
        //   }
        // });
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.initPageParams();
  },
  methods: {
    ...mapMutations({
      setDefaultChecked: "setDefaultChecked",
      clearChecked: "clearChecked"
    }),
    initData(data) {
        this.selectUser.current = 1;
        this.principal = data.principal ? data.principal : false
        this.selectedUserIdArr = JSON.parse(JSON.stringify(data.defaultSelected));
      this.selectedUserListArr = JSON.parse(
        JSON.stringify(data.selectedUserListArr)
      );
      // this.$nextTick(()=>{
      this.getMixQueryUserPageData();
      // })
    },
    initPageParams() {
      this.activeName = "1";
      this.selectedRoleId = "";
      this.selectedLabelId="";
      this.selectedUserIdArr = [];
      this.selectedUserArr = [];
      this.type = this.typeData[0].id;
      this.teacherType = -1;
      this.currentTeacherType = "";
      this.personType = -1;
      this.sortType = 0;
      this.nameIndexValue = 0;
      this.nameIndex = null;
      this.sortOrder = true;
      this.selectUser.current = 1;
      // this.deptArr = [2];
      this.deptArr = [];
      this.$nextTick(() => {
        this.treeKey = Date.parse(new Date());
        this.deptUserData = [];
        this.clearChecked();
        this.handleClickedId = Object.assign(this.handleClickedId, {
          data: this.deptArr[0],
          key: Date.parse(new Date())
        });
        this.getNodeId(this.deptArr[0]);
        this.setDefaultChecked(this.deptArr);
      });
    },
    userSearch() {
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    clearUserName() {
      this.userName = "";
      this.getMixQueryUserPageData();
    },
    UserCurrentChange(val) {
      this.selectUser.current = val;
      this.getMixQueryUserPageData();
    },
    selectionChange(val) {
      this.chooseAll && (this.chooseAll = false);
    },
    allSelectionChange(selection) {
      if (selection.length > 0) {
        selection.forEach((item, index) => {
          if (!this.selectedUserIdArr.includes(Number(item.userId))) {
            this.selectedUserIdArr.push(Number(item.userId));
            this.selectedUserListArr.push(item);
          }
        });
      } else {
        this.deptUserData.forEach((item, index) => {
          const selectIndex = this.selectedUserListArr.findIndex(e => {
            return (e.directorId || e.userId) == item.userId;
          });
          this.selectedUserIdArr.splice(selectIndex, 1);
          this.selectedUserListArr.splice(selectIndex, 1);
        });
      }
    },
    handleSelect(selection, row) {
      this.multipleDeptUser = selection;
      this.chooseAll = false;
      if (!selection.includes(row)) {
        const selectIndex = this.selectedUserListArr.findIndex(e => {
          if (Object.keys(row).includes("directorId")) {
            return e.userId == String(row.directorId);
          } else {
            return e.userId == String(row.userId);
          }
        });
        this.selectedUserIdArr.splice(selectIndex, 1);
        this.selectedUserListArr.splice(selectIndex, 1);
      } else {
        if (!this.selectedUserIdArr.includes(Number(row.userId))) {
          this.selectedUserIdArr.push(Number(row.userId));
          this.selectedUserListArr.push(row);
        }
      }
    },
    handleClick(tab, event) {
      this.type = this.typeData[0].id;
      this.teacherType = -1;
      this.personType = -1;
      this.sortType = 0;
      this.nameIndexValue = 0;
      this.nameIndex = null;
      this.sortOrder = true;
      this.selectUser.current = 1;
    },
    getNodeId(data) {
      if (Object.prototype.toString.call(data) === "[object Object]") {
        this.currentDeptId = data.id;
      } else {
        this.currentDeptId = data;
      }
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    // 设置选择的系统角色
    setSelectedRoleId(row) {
      this.selectedRoleId = row.roleId;
      this.cardActiveId = row.roleId;
      this.getMixQueryUserPageData();
    },
      // 设置选择的标签
      setSelectedLabelId(row) {
          this.selectedLabelId= row.labelId;
          this.cardActiveId = row.labelId;
          this.getMixQueryUserPageData();
      },
    // 设置选择的负责人
    setSelectedPersonId(row) {
      this.selectedPersonId = row.deptId;
      this.cardActiveId = row.deptId;
      this.getMixQueryUserPageData();
    },
    getMixQueryUserPageData() {
      let params = {
        userName: this.userName,
        current: this.selectUser.current,
        size: this.selectUser.pageSize,
        // chargeType: this.personType + 1,
        // levelId: this.currentTeacherType.value || "",
        // queryType: Number(this.activeName) - 1,
        // deptId: this.currentDeptId,
        // roleId: this.selectedRoleId,
        // userType: this.type,
        // sortOrder: this.sortType == 1 ? "ASC" : "DESC",
        nameIndex: this.nameIndex == "全部" ? "" : this.nameIndex
      };
      switch (this.activeName) {
        case "1":
          params.deptId = this.currentDeptId;
          break;
        case "3":
          params.roleId = this.selectedRoleId;
          break;
        case "4":
          params.chargeType = this.personType + 1;
          params.relationId = this.selectedPersonId;
          break;
        case "5":
          params.levelId = this.currentTeacherType.value || "";
          params.seriesId=this.currentSeriesId || null;
          break;
        case "6":
          params.labelId = this.selectedLabelId;
              break;
        default:
      }
      this.selectUserLoading = true;
      getListTableUrl(params).then(res => {
        if (res.data.code == 0) {
            this.selectedUserIdArr=this.selectedUserIdArr.map(i=>Number(i));
          this.selectUserLoading = false;
          this.deptUserData = res.data.data.records;
          this.$nextTick(() => {
            if (this.deptUserData.length > 0) {
              this.deptUserData.forEach(item => {
                if (
                  this.selectedUserIdArr.includes(Number(item.userId)) &&
                  this.$refs.multipleRoleUserTable
                ) {

                  this.$refs.multipleRoleUserTable.toggleRowSelection(
                    item,
                    true
                  );
                } else {
                  this.$refs.multipleRoleUserTable &&
                    this.$refs.multipleRoleUserTable.toggleRowSelection(
                      item,
                      false
                    );
                }
              });
            }
          });
          this.selectUser.total = res.data.data.total;
        }
      });
    },
    typeClick(item) {
      this.type = item.id;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    teacherTypeClick(item, int) {
      this.currentTeacherType = item;
      this.teacherType = int - 1;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    personTypeClick(item, int) {
      this.personType = int - 1;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    nameClick(item, int) {
      this.nameIndexValue = int;
      this.nameIndex = item;
      this.selectUser.current = 1;
      this.getMixQueryUserPageData();
    },
    sortClick(item, int) {
      this.sortType = int;
      this.sortOrder = !this.sortOrder;
      this.getMixQueryUserPageData();
    },
    filterFun(source) {
      source.filter((child, index) => {
        if (child.expanded) {
          child.expanded = false;
        }
        if (child.childNodes && child.childNodes.length > 0) {
          this.filterFun(child.childNodes);
        }
      });
    },
    expendNodeCollapse(data, node) {
      if (data.level === 1) {
        this.personType = data.id - 1;
        this.selectedPersonId = "";
        this.cardActiveId = "";
      } else {
        this.selectedPersonId = data.id;
        this.cardActiveId = data.id;
      }
      this.getMixQueryUserPageData();
      this.nodeData = node;
      node.parent.childNodes.filter(child => {
        if (child.data.id !== node.data.id) {
          this.filterFun([child]);
        }
      });
    },
    handleNodeClick(data) {
      if (data.level === 1) {
        this.personType = data.id - 1;
        this.selectedPersonId = "";
        this.cardActiveId = "";
      } else {
        this.personType = data.parentId - 1;
        this.selectedPersonId = data.id;
        this.cardActiveId = data.id;
      }
      this.getMixQueryUserPageData();
    },
    handleSeriesNodeClick(data) {
      if (this.currentSeriesId !== data.value) {
        this.currentSeriesId = data.value;
        this.selectUser.current = 1;
        this.getTeacherType();
      }
    },
    expendSeriesNodeCollapse(data, node) {},
    getSeriesData() {
      majorType("teacher_series").then(res => {
        this.seriesData = res.data.data;
        let obj={
            id:0,
            value:0,
            label:'全部'
        }
        this.seriesData.unshift(obj);
        this.seriesData.forEach((item, index) => {
          if (index === 0) {
            this.$nextTick(() => {
              this.defaultSeriesExpandIds.push(item.id);
              this.$refs["seriesTree"].setCurrentKey(item.id);
              this.getTeacherType();
            });
          }
        });
      });
    },
    getDeptChargeManList(page, params) {
      this.selectUserLoading = true;
      getDeptChargeMan(
        Object.assign(
          {
            current: this.page.currentPage,
            size: this.page.pageSize
          },
          this.params
        )
      ).then(response => {
        this.personTypeData[0].children = response.data.data.records;
        this.personTypeData[0].children.forEach((item, index) => {
          item.label = item.name;
          item.id = item.deptId;
          item.level = 2;
          item.parentId = 0;
        });
        this.selectUserLoading = false;
      });
    },
    getMajorsManList(page, params) {
      this.selectUserLoading = true;
      getMajorsMan(
        Object.assign(
          {
            current: this.page.currentPage,
            size: this.page.pageSize
          },
          this.params
        )
      ).then(response => {
        this.personTypeData[1].children = response.data.data.records;
        this.personTypeData[1].children.forEach((item, index) => {
          item.label = item.majorName;
          item.id = item.majorId;
          item.level = 2;
          item.parentId = 1;
        });
        this.selectUserLoading = false;
      });
    },
    getClassManList(page, params) {
      this.selectUserLoading = true;
      getClassMan(
        Object.assign(
          {
            current: this.page.currentPage,
            size: this.page.pageSize
          },
          this.params
        )
      ).then(response => {
        this.personTypeData[2].children = response.data.data.records;
        this.personTypeData[2].children.forEach((item, index) => {
          item.label = item.className;
          item.id = item.classId;
          item.level = 2;
          item.parentId = 2;
        });
        this.selectUserLoading = false;
      });
    },
    getSubjectManList(page, params) {
      this.selectUserLoading = true;
      getSubjectMan(
        Object.assign(
          {
            current: this.page.currentPage,
            size: this.page.pageSize
          },
          this.params
        )
      ).then(response => {
        this.personTypeData[3].children = response.data.data.records;
        this.personTypeData[3].children.forEach((item, index) => {
          item.label = item.groupName;
          item.id = item.groupId;
          item.level = 2;
          item.parentId = 3;
        });
        this.selectUserLoading = false;
      });
    },
    getTeacherType() {
      if (this.teacherTypeData.length === 0) {
        this.selectUserLoading = true;
        majorType("teacher_level").then(res => {
          this.teacherTypeData = res.data.data;
          this.teacherType = -1;
          this.currentTeacherType = this.teacherTypeData[0];
          this.getMixQueryUserPageData();
          this.selectUserLoading = false;
        });
      } else {
        this.teacherType = -1;
        this.currentTeacherType = this.teacherTypeData[0];
        this.getMixQueryUserPageData();
      }
    },
    getRoleListData() {
      this.selectUserLoading = true;
      getRoleList({ searchName: this.searchRoleName }).then(res => {
        this.systemRoleData = res.data.data;
        this.getMixQueryUserPageData();
        this.selectUserLoading = false;
      });
    },
      // 获取标签列表
      getLabelListFn(){
          getAllLabelList().then(({data}) => {
              if(data.code == 0){
                  this.labelList=data.data||[];
                  if(this.labelList.length){
                      this.$nextTick(()=>{
                          this.setSelectedLabelId(this.labelList[0]);
                      })
                  }else{
                      this.getMixQueryUserPageData();
                  }

              }else{
                  this.$message.warning( data.msg||"获取标签列表失败！" );
              }
          })
      },
      delAll(){
          this.selectedUserIdArr = []
          this.selectedUserListArr = []
          this.deptUserData.forEach(item => {
                  this.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
          });
      },
    // 删除被选中的用户
    delSelectedUser(row) {
      const selectIndex = this.selectedUserListArr.findIndex(e => e === row);
      this.selectedUserIdArr.splice(selectIndex, 1);
      this.selectedUserListArr.splice(selectIndex, 1);
      const rowId = row.directorId || row.userId;
      this.deptUserData.forEach(item => {
        if (item.userId == rowId) {
          this.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
        }
      });
    },
    // 关闭用户选择
    handleDialogClose() {
      this.$emit("closeSelectUser");
    },
    sureClick(flag, data) {
      let searchParams = {
        keywords: this.userName,
        // queryType: Number(this.activeName) - 1,
        // sortOrder: this.sortType == 1 ? "ASC" : "DESC",
        nameIndex: this.nameIndex == "全部" ? "" : this.nameIndex,
        // userType: this.type,
        directors: this.selectedUserIdArr,
        selectAllUser: this.chooseAll ? 1 : 0
      };
      switch (this.activeName) {
        case "1":
          searchParams.deptId = this.currentDeptId;
          break;
        case "3":
          searchParams.roleId = this.selectedRoleId;
          break;
        case "4":
          searchParams.chargeType = this.personType + 1;
          searchParams.deptId = this.selectedPersonId;
          break;
        case "5":
          searchParams.levelId = this.currentTeacherType.value || "";
          searchParams.seriesId=this.currentSeriesId || null;
          break;
          case "6":
              searchParams.labelId = this.selectedLabelId;
              break;
        default:
      }
      if (flag) {
        this.$confirm(`确定将选择全部用户!`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(action => {
            this.chooseAll = true;
            this.$emit("selectResult", {
              type: flag,
              data: [data],
              param: searchParams
            });
          })
          .catch(error => {
            if (error === "cancel") {
            }
          });
      } else {
        if (data) {
          searchParams.directors = [data.userId];
          this.$emit("selectResult", {
            type: flag,
            data: [data],
            param: searchParams
          });
        } else {
          this.$emit("selectResult", {
            type: flag,
            data: this.selectedUserListArr,
            param: searchParams
          });
        }
      }
    }
  }
};
</script>
<style lang="less">
@import "./selectUser.less";
</style>
